import React from 'react'
import {ProductDataType} from '@/types/product'
import {useProductContext} from '../../context/ProductContext'

interface BundledProductProps {
    bundledProduct: ProductDataType
}

const BundledProduct: React.FC<BundledProductProps> = ({bundledProduct}) => {
    // Defensive check for product
    const product = bundledProduct?.product || bundledProduct
    const quantity = bundledProduct?.quantity || 1
    const {product: parentProduct} = useProductContext()

    // Defensive check for imageGroups
    const firstImageGroup =
        product && Array.isArray(product.imageGroups) && product.imageGroups.length > 0
            ? product.imageGroups[0]
            : undefined
    const firstImage =
        firstImageGroup &&
        Array.isArray(firstImageGroup.images) &&
        firstImageGroup.images.length > 0
            ? firstImageGroup.images[0]
            : undefined
    const image_url = firstImage?.link || firstImage?.image_url || ''
    const imageAlt = firstImage?.alt || ''

    // Custom URL logic
    const getBundledProductUrl = () => {
        if (!parentProduct?.url || !product?.id) return '#'
        // Extract path from parent URL, stripping any origin to keep links relative
        const match = parentProduct.url.match(/^(?:https?:\/\/[^/]+)?\/?(?:.*\/)?([\w-]+)\.html$/)
        if (!match) return parentProduct.url
        return `/${String(product.id)}.html`
    }
    const bundledProductUrl = getBundledProductUrl()

    return (
        <a
            href={bundledProductUrl}
            className="w-full flex items-center p-3 bg-white hover:bg-gray-50 cursor-pointer no-underline"
            data-testid="bundledProduct-button"
        >
            <div className="flex items-center w-full">
                <div className="w-16 h-16 flex-shrink-0 mr-4 rounded overflow-hidden bg-gray-100 flex items-center justify-center">
                    <img src={image_url} alt={imageAlt} className="object-cover w-full h-full" />
                </div>
                <div className="flex flex-col flex-1 text-left justify-center">
                    <span className="font-medium text-[#142745] text-base leading-tight">
                        {product.name}
                    </span>
                    <span className="font-medium text-[#142745] text-base mt-1">
                        Qty: <span className="text-xs">{quantity}</span>
                    </span>
                </div>
            </div>
        </a>
    )
}

export default BundledProduct
